module.exports = __webpack_public_path__ + "static/media/15.e3107850.png";